import React from 'react';
import PricingPage from './components/PricingDiv';
import FaqComponent from './components/FAQComponent';
import PricingHeader from './components/HeaderComponent';
// Adding a media query for responsive design
const ResponsivePricingPage = () => {
  const [windowWidth, setWindowWidth] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <style>
        {`
          @media (max-width: 768px) {
            .pricing-container {
              grid-template-columns: 1fr !important;
            }
            .pricing-title {
              font-size: 2rem !important;
            }
            .pricing-subtitle {
              font-size: 1.5rem !important;
            }
          }
        `}
      </style>
      <PricingHeader title='Pricing: plans for every research need' description={`Choose the plan that's right for your plastic analysis requirements, from individual researchers to enterprise solutions.`} />
      <PricingPage />
      <FaqComponent />
    </div>
  );
};

export default ResponsivePricingPage;